export default "__VITE_ASSET__BbyY69L4__"